(function () {
  'use strict';

  function initHeaderAtc() {
    var button = document.querySelector('[data-mcocod-header-atc]');
    var icons = button && button.closest('.t4s-site-nav__icons, .mhh-tools');
    var boundary = document.querySelector('.t4s-section-main-product .t4s-product__price-review') ||
      document.querySelector('.t4s-section-main-product .t4s-product__info-wrapper');
    var desktop = window.matchMedia('(min-width: 1025px)');

    if (!button || !icons || !boundary || !getSourceButton() || button.dataset.mcocodReady === 'true') return;

    button.dataset.mcocodReady = 'true';
    button.hidden = false;

    var utilityItems = Array.prototype.slice.call(icons.querySelectorAll(
      '.t4s-site-nav__account, .t4s-site-nav__heart, .t4s-site-nav__cart, .mhh-search-btn, .mhh-acct, .mhh-wish'
    ));

    function getSourceButton() {
      return document.querySelector('.t4s-section-main-product .t4s-product__info-wrapper .button-add-to-card');
    }

    function sourceIsDisabled(source) {
      return !source || source.hasAttribute('disabled') || source.getAttribute('aria-disabled') === 'true';
    }

    function sourceIsLoading(source) {
      var loader = source && source.querySelector('.loading');
      return Boolean(loader && !loader.classList.contains('hidden'));
    }

    function getCurrentPrice() {
      var price = document.querySelector('.t4s-section-main-product price-total .sale-price, .t4s-section-main-product price-total .price');
      return price && price.textContent.trim() ? price.textContent.trim().replace(/\s+/g, ' ') : '';
    }

    function renderButtonLabel(label, price) {
      if (label.toLowerCase().indexOf('add to cart') === -1 || !price) {
        button.textContent = label;
        return;
      }

      var labelNode = document.createElement('span');
      labelNode.className = 'mcocod-header-atc__label';
      labelNode.textContent = label;
      var priceNode = document.createElement('span');
      priceNode.className = 'mcocod-header-atc__price';
      priceNode.textContent = price;
      button.replaceChildren(labelNode, priceNode);
    }

    function syncButton() {
      var source = getSourceButton();
      var sourceLabel = source && source.querySelector('.t4s-btn-atc_text, .super-buy-button-text.add-to-cart, .add-to-cart');
      var label = sourceLabel ? sourceLabel.textContent.trim().replace(/\s+/g, ' ') : '';
      var price = getCurrentPrice();
      var loading = sourceIsLoading(source);
      if (label) renderButtonLabel(label, price);
      button.classList.toggle('is-loading', loading);
      button.setAttribute('aria-busy', String(loading));
      button.disabled = sourceIsDisabled(source) || loading;
      button.setAttribute('aria-disabled', String(button.disabled));
    }

    function setUtilityAccessibility(active) {
      utilityItems.forEach(function (item) {
        var control = item.matches('a, button') ? item : item.querySelector('a, button');
        item.setAttribute('aria-hidden', String(active));
        if (!control) return;

        if (!control.hasAttribute('data-mcocod-original-tabindex')) {
          control.setAttribute('data-mcocod-original-tabindex', control.getAttribute('tabindex') || 'none');
        }

        if (active) {
          control.setAttribute('tabindex', '-1');
        } else if (control.getAttribute('data-mcocod-original-tabindex') === 'none') {
          control.removeAttribute('tabindex');
        } else {
          control.setAttribute('tabindex', control.getAttribute('data-mcocod-original-tabindex'));
        }
      });
    }

    function setActive(active) {
      active = Boolean(active && desktop.matches);
      icons.classList.toggle('is-mcocod-header-atc-active', active);
      button.setAttribute('aria-hidden', String(!active));
      button.tabIndex = active ? 0 : -1;
      setUtilityAccessibility(active);
    }

    syncButton();

    var source = getSourceButton();
    if (source) {
      new MutationObserver(syncButton).observe(source, {
        attributes: true,
        attributeFilter: ['aria-disabled', 'class', 'disabled'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    var priceTotal = document.querySelector('.t4s-section-main-product price-total');
    if (priceTotal) {
      new MutationObserver(syncButton).observe(priceTotal, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    function syncActive() {
      var boundaryBottom = boundary.getBoundingClientRect().bottom;
      setActive(boundaryBottom <= 64 && window.scrollY > 180);
    }

    var boundaryObserver = new IntersectionObserver(syncActive, {
      rootMargin: '-64px 0px 0px 0px',
      threshold: [0, 1]
    });

    boundaryObserver.observe(boundary);
    window.addEventListener('scroll', syncActive, { passive: true });
    window.addEventListener('resize', syncActive, { passive: true });
    syncActive();

    button.addEventListener('click', function () {
      var liveSource = getSourceButton();
      syncButton();
      if (!button.disabled) liveSource.click();
    });

    desktop.addEventListener('change', function () {
      syncActive();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderAtc, { once: true });
  } else {
    initHeaderAtc();
  }

  document.addEventListener('shopify:section:load', initHeaderAtc);
}());
